import React, { useState } from 'react'
import { isLoaded, useFirebase, firestoreConnect } from 'react-redux-firebase'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  // CardTitle,
  CardHeader,
  CardText,
  Button,
  Spinner,
  Modal,
  ModalBody,
} from 'reactstrap'
import { Redirect, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
// import Checkbox from '@material-ui/core/Checkbox'

import moment from 'moment'
import 'moment/locale/fi'
import { Divider } from '@material-ui/core'
import PaymentRedirect from '../PaymentRedirect'
import PaymentOptions from '../PaymentOptions'
import { useEffect } from 'react'
import { compose } from 'redux'
import { useTranslation } from 'react-i18next'
import { useCookies } from 'react-cookie'
import withAppconfig from '../../AppContext'
import Payments from '../../components/Payments'
import { getWallet } from '../../components/ViewUtils'
import Giftcode from '../../components/Giftcode'
import PlusMinusButton from '../../components/Shop/PlusMinusButton'

const enhance = compose(
  connect((state) => ({ auth: state.firebase.auth })),
  firestoreConnect((props) => [
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        { collection: 'paymentinfo', doc: 'saldo', subcollections: [{ collection: `${props.appconfig.accountkey}` }] },
      ],
      storeAs: 'wallets',
    },
  ]),
  connect(({ payable: { selected }, firebase: { auth, profile }, firestore, globaltime: { gtime } }, { appconfig }) => {
    if (selected) {
      // console.log('selected', selected)
      const summary = { price: 0 }
      let wallet = []
      const walletName = getWallet(appconfig, summary)
      if (firestore.data['wallets'] && firestore.data['wallets'][walletName]) {
        wallet = firestore.data['wallets'][walletName]
      }
      const cashsum =
        wallet && wallet.cash
          ? wallet.cash.reduce((acc, curr) => {
              acc = acc + curr.amount
              return acc
            }, 0)
          : 0

      const sportmoneysum =
        wallet && wallet.sportmoney
          ? wallet.sportmoney.reduce((acc, curr) => {
              acc = acc + curr.amount
              return acc
            }, 0)
          : 0

      return {
        auth,
        profile,
        selected,
        summary,
        cashsum,
        sportmoneysum,
        wallet: firestore.data['wallets'] || [],
        memberships: [],
        gtime
      }
    } else {
      return {
        auth,
        profile,
        selected,
        summary: {},
        cashsum: 0,
        sportmoneysum: 0,
        memberships: [],
        gtime
      }
    }
  })
)

const _getVatAmount = (sumIncVat, vat, returnFloat) => {
  if (!vat) return "0"
  const vatDivider = 1 + (vat / 100)
  const sumExVat = sumIncVat / vatDivider
  const vatAmount = sumIncVat - sumExVat
  return returnFloat ? vatAmount : vatAmount.toFixed(2)
}

function CartItem({ item, onChangeCount }) {
  return (
    <Row key={'selected-' + item.id} className={'loose'}>
      <Col xs={2} sm={2}>
        {item.poster ? <img src={item.poster.url} alt={item.displayName} style={{ width: 50, height: 50 }} /> : null}
        </Col>
      <Col>{item.displayName} - {item.selectedVariant.name}
</Col>
      <Col style={{ textTransform: 'capitalize' }} className={'text-right'}>
        {item.selectedVariant.price > 0 ? (item.count * item.selectedVariant.price / 100).toFixed(2).replace('.', ',') + ' €' : ''}
      </Col>
      <Col className={'text-right'}>
        <PlusMinusButton 
          defaultValue={item.count}
          onChange={(value) => {  
            item.count = value
            if (onChangeCount) {
              onChangeCount(item, value)
            }
          }}
        loading={false}
        max={item.selectedVariant.amount || 99}
        disabled={false}
        />
      </Col>

    </Row>
  )
}

const ProshopPaymentScreen = ({
  auth,
  profile,
  selected,
  summary,
  cashsum,
  sportmoneysum,
  wallet,
  dispatch,
  appconfig,
  memberships,
  gtime
}) => {
  const firebase = useFirebase()
  let history = useHistory()
  let defaultLanguage = 'FI'
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const [renderPayments, setRenderPayments] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useState(null)
  // const [payments, setPayments] = useState(null)
  const [errorNotification, setErrorNotification] = useState(null)
  const [onlinepaymentprovider, setOnlinePaymentProvider] = useState(null)
  const [initdone, setInitDone] = useState(false)
  // const [usernote, setUserNote] = useState(null)
  const [membershipprices, setMembershipPrices] = useState(null)
  const [giftcoderedeem, setGiftcoderedeem] = useState(null)
  const [pricescheck, setPricesCheck] = useState(false)
  const [cartItems, setCartItems] = useState(selected)

  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['selectedLanguage'])
  if (cookies.selectedLanguage) {
    defaultLanguage = cookies.selectedLanguage
  }

  useEffect(() => {
    moment.locale(defaultLanguage.toLowerCase(), { week: { dow: 3 } })
  }, [defaultLanguage])
  const loaded = isLoaded(profile) && isLoaded(wallet) && selected

  if (loaded && !initdone) {
    setInitDone(true)
  }

  const goProshop = () => {
    dispatch({
      type: 'CLEAR_PAYABLE_PROSHOP',
      payload: null,
    })
    history.push(appconfig.pathPrefix + '/shop/proshop')
  }

  const setPaymentProvider = (p) => setOnlinePaymentProvider(p)

  const payProshopOrder = async (selectedPayments) => {
    setLoading(true)
    const payableObject = {
      customerid: appconfig.accountkey,
      paymentmethod: selectedPayments,
      items: cartItems.map((x) => ({ id: x.id, count: x.count, variant: x.selectedVariant, displayName: x.displayName })).filter((x) => x.count > 0),
      collection: 'proshopproducts',
    }

    if (giftcoderedeem) {
      payableObject.giftcode = giftcoderedeem
    }

    const shouldRenderOptions = cartItems.reduce((acc, p) => acc + (p.selectedVariant ? p.selectedVariant.price * p.count : 0), 0) > 0
    const shouldRedict = shouldRenderOptions
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testproshop-pay' : 'proshop-pay'
    const proshopPayment = firebase.functions().httpsCallable(fn)
    try {
      let response = await proshopPayment(payableObject)
      if (response.data.error) {
        setLoading(false)
        setErrorNotification(response.data.error)
      } else if (shouldRenderOptions) {
        setRenderPayments(true)
      } else if (shouldRedict) {
        setRedirect(true)
      } else {
        setLoading(false)

        history.push(appconfig.pathPrefix + '/shop/proshop')
      }
    } catch (error) {
      alert(error.message)
      // console.log(error)
      setLoading(false)
    }
  }

  const updateItemCount = (product, value) => {
    if(value < 1) {
      const index = cartItems.findIndex((p) => p.id === product.id && p.selectedVariant?.varid === product.selectedVariant?.varid)
      if(index > -1) {
        cartItems.splice(index, 1)
      }
      setCartItems([...cartItems])
    } else {
      const updatedProduct = { ...product, count: value }
      // if cart already has this product with same variant, update count
      const existingProduct = cartItems.find((p) => p.id === updatedProduct.id && p.selectedVariant?.varid === updatedProduct.selectedVariant?.varid)
      if (existingProduct) {
        existingProduct.count = value
      }
      setCartItems([...cartItems])
    }
  }

  const updateItemPricing = (prices) => {
    if (prices && prices.length > 0) {
      prices.sort((a, b) => a.price - b.price)
    }
    let membershipids =  memberships.map((v) => v.membershipid ) //Object.keys(memberships || {}).map((key) => {
    //   return memberships[key].membershipid
    // })
    let _membershipprices = prices.filter((x) => {
      if (x.membershipid) {
        return membershipids.includes(x.membershipid)
      } else {
        return true
      }
    })
    // console.log('membershipprices', _membershipprices, 'selected', { ...selected })
    const originalPrice = selected.price
    if (_membershipprices && _membershipprices.length > 0) {
      selected.price = _membershipprices[0].price
    }
    if (_membershipprices.length > 0) {
      selected.overridecost = true
      const gen = {
        pricing: 'general', price: originalPrice
      }
      _membershipprices.push(gen)
      // membershipprices.find((x) => x.pricing === 'general')
      // selected.general = gen
    }
    setMembershipPrices(_membershipprices)
  }

  const onValidGiftcode = (membershipprices, giftcode) => {
    setGiftcoderedeem(giftcode)
    updateItemPricing(membershipprices)
  }

  if (!selected) {
    return <Redirect to='/' />
  }

  if (renderPayments) {
    return (
      <PaymentOptions
        selectedGw={'pc'}
        authorization={token}
        provider={onlinepaymentprovider}
        disabledmethods={appconfig.disabledpaymentmethods || []}
        onCancel={() => { }}
        cancellable={{ id: cartItems[0]?.id, type: 'membership' }}

      />
    )
  } else if (redirect) {
    return <PaymentRedirect selectedGw={'pc'} authorization={token} />
  }

  if (!loaded) {
    return (
      <div className='full-page-background'>
        <Container className='login-dialog'>
          <Spinner /> Loading ...
        </Container>
      </div>
    )
  } else {
    
    console.log('ProshopPaymentScreen', { cartItems, memberships, membershipprices })

    const totalPrice = cartItems.reduce((acc, p) => acc + (p.selectedVariant ? p.selectedVariant.price * p.count : 0), 0)
    const totalVat = cartItems.reduce((acc, p) => acc + (p.selectedVariant ? _getVatAmount(p.selectedVariant.price * p.count, p.vat, true) : 0), 0)
    const totalShipping = cartItems.reduce((acc, p) => acc + (p.selectedVariant && p.selectedVariant.shippingcost ? p.selectedVariant.shippingcost : 0), 0)

    return (
      <div className='full-page-background'>
        <Container className='login-dialog'>
          <Row>
            <Col md='8' className='mx-auto'>
              <Card>
                <CardHeader tag='h4'>{t('cart')}</CardHeader>
                <CardBody>
                  {cartItems && cartItems.map((x => {
                    return x.count > 0 && <CartItem key={'cartitem-' + x.id} item={x} onChangeCount={updateItemCount} />
                  }))}
                  <Divider />
                  <Row className={'loose'}>
                    <Col>{t('total')} ({t('including_taxes')})</Col>
                    <Col className={'text-right'}>
                      {totalPrice > 0
                        ? (totalPrice / 100).toFixed(2).replace('.', ',') + ' €'
                        : ''}
                    </Col>
                  </Row>
                  <Row className={'loose'}>
                    <Col>{t('taxes')}</Col>
                    <Col className={'text-right'}>
                      {totalVat > 0
                        ? (totalVat / 100).toFixed(2).replace('.', ',') + ' €'
                        : ''}
                    </Col>
                  </Row>
                  {totalShipping > 0 && <Row className={'loose'}>
                    <Col>{t('shipping')}</Col>
                    <Col className={'text-right'}>
                        {(totalShipping / 100).toFixed(2).replace('.', ',') + ' €'}
                    </Col>
                  </Row>}
                  <Divider />
                  <Row className={'loose'}>
                    <Col>{t('total')} ({t('including_taxes_and_shipping')})</Col>
                    <Col className={'text-right'}>
                      {totalPrice + totalShipping > 0
                        ? ((totalPrice + totalShipping) / 100).toFixed(2).replace('.', ',') + ' €'
                        : '0,00 €'}
                    </Col>
                  </Row>
                  <Divider />
                  <Row className={'loose'}>
                    <Col xs={4} sm={3}>
                      <Giftcode
                        selected={selected}
                        membershipprices={membershipprices}
                        pricesCheckState={setPricesCheck}
                        onValidGiftcode={onValidGiftcode}
                        producttype='activity'
                      />
                    </Col>
                  </Row>
                  <CardText></CardText>
                  <Payments
                    benefitPurchase={{ collection: 'proshop', customerid: appconfig.accountkey }}
                    price={(totalPrice + totalShipping) / 100}
                    selecttype='payable'
                    unallowedmethods={['cashier', 'cashstore', 'minutestore', 'cashwallet', 'benefitcard']}
                    buttonText={t('pay') + ' ' + ((totalPrice + totalShipping) / 100).toFixed(2).replace('.', ',') + ' €'}
                    buttonAction={payProshopOrder}
                    errorNotification={errorNotification}
                    setPaymentProvider={setPaymentProvider}
                    ready={true}
                    nooverridemetohods={['cashier', 'cashstore', 'minutestore', 'cashwallet','benefitcard']}
                  />
                  <Button size='small' color='link' className='text-muted' onClick={() => goProshop()}>
                    <ChevronLeftIcon /> {t('back_to_proshop')}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* <Row>
            <Col>
            <pre>{JSON.stringify( cartItems , null, 2)}</pre>
            </Col>
          </Row> */}
        </Container>
        <Modal
          size='sm'
          centered
          isOpen={loading}
          backdrop={true}
          wrapClassName={'al-wrap'}
          modalClassName={'al-modal'}
          contentClassName={'loading-spinner'}
        >
          <ModalBody className='text-center'>
            <Spinner color='light' /> <p style={{ color: 'white' }}>Vahvistetaan</p>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default withAppconfig(enhance(ProshopPaymentScreen))
